export default __webpack_public_path__ + "static/media/spacewalking.0cc5533d.svg";